import { render, staticRenderFns } from "./addressSetting.vue?vue&type=template&id=6789a386&scoped=true&"
import script from "./addressSetting.vue?vue&type=script&lang=js&"
export * from "./addressSetting.vue?vue&type=script&lang=js&"
import style0 from "./addressSetting.vue?vue&type=style&index=0&id=6789a386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6789a386",
  null
  
)

export default component.exports